import { EnvironmentModel } from "./environment.model";

export const environment: EnvironmentModel = {
  dataUrl: 'https://api.younium.com/paywall',
  apiUrl: 'https://api.younium.com/paywall',
  production: true,
  wsUrl: 'https://api.younium.com/paywall'
}